/**
 * @author Sirisha.M
 * @description 
 */
import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { config } from '../../constant';
import ReactEcharts from '../../Echarts/Echarts';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { confusionMatrixMockJson } from '../../../Mock/MockJson';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const ConfusionMatrix = (props) => {
  const [option, setOption] = useState({});
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [seriesData, setSeriesData] = useState([]);

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
    translationCache
  } = props;


  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    translationCache
  ]);


  const getData = async () => {
    requestCheck.current = false;
    let json = [];
    const { graphprops } = props;
    let newOption = getOption();
    let newErrorInAPI = false;
    let newNoDataInDB = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = confusionMatrixMockJson;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        newErrorInAPI = true;
      } else if (json.length === 0) {
        newNoDataInDB = true;
      }
    } else {
      if (json && Array.isArray(json)) {
        setSeriesData(json);
        newOption.series.data = json;
        setOption(newOption);
        setRefreshDateTime(moment());
      }
    }
    setErrorInAPI(newErrorInAPI);
    setNoDataInDB(newNoDataInDB);
  };


  const getOption = () => {
    let option = {
      tooltip: {
        position: 'top'
      },
      grid: {
        height: '50%',
        top: '10%'
      },
      xAxis: {
        type: 'category',
        nameLocation: 'middle',
        name: 'Predicted Label',
        data: [0, 1],
        splitArea: {
          show: true
        }
      },
      yAxis: {
        type: 'category',
        name: 'True Label',
        nameLocation: 'middle',
        data: [0, 1],
        splitArea: {
          show: true
        }
      },
      visualMap: {
        min: 0,
        max: 100,
        calculable: true,
        orient: 'horizontal',
        left: 'center',
        bottom: '15%',
        show: false,
        inRange: {
          color: ['green', 'yellow']
        }
      },
      series: [
        {
          name: 'ConfusionMatrix',
          type: 'heatmap',
          label: {
            show: true,
            position: 'inside'
          },
          data: seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0,0,0,0.5)',
              borderColor: 'rgb(230, 226, 23)'
            }
          }
        }
      ]
    };
    return option;
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          id={Math.ceil(Math.random(100, 100000) * 1000)}
          option={option}
          style={{
            height: '100%',
            width: '100%'
          }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(ConfusionMatrix);
